import _ from "lodash";
import { api } from "../../server/request";
import { Category, AllowedDomain, BlockedDomain, Domain } from "./types";
import {handleResponseObj} from "../../actions/responseUtil";
import { toast } from "react-toastify";

const ACTION_TYPES = {
    SET_LOADING: "contentFilter/setLoading",
    SET_DP_IDS: "contentFilter/setDpIds",

    GET_CONTENT_FILTERS: "contentFilter/getContentFilters",
    SET_CONTENT_FILTER_COUNT: "contentFilter/setContentFilterCount",
    GET_CONTENT_FILTERS_LOGS: "contentFilter/getContentFiltersLogs",
    CREATE_CONTENT_FILTER: "contentFilter/createContentFilter",
    UPDATE_CONTENT_FILTER: "contentFilter/updateContentFilter",
    DELETE_CONTENT_FILTER: "contentFilter/deleteContentFilter"
}

const initialState = {
    dpIds: [],

    contentFilters: [],
    totalContentFilters: 0,
    gettingContentFilters: false,
    createContentFilter: {},
    creatingContentFilter: false,
    updateCF: {},
    updatingContentFilter: false,
    deleteContentFilter: {},
    deletingContentFilter: false,   
    applyingTrafficPolicy: false,   
    contentFilterLogs: {}
}

export function contentFilterReducer(state: any = initialState, action) {
    switch (action.type) {
        case ACTION_TYPES.SET_DP_IDS: {
            return {
                ...state,
                dpIds: action.payload
            }
        }
        case ACTION_TYPES.GET_CONTENT_FILTERS: {
            // console.log("DBG: action.payload", action.payload);
            return {
                ...state,
                contentFilters: action.payload?.data ? action.payload.data : [],
            }
        }
        case ACTION_TYPES.SET_LOADING: {
            return {
                ...state,
                ...action.payload
            }
        }
        case ACTION_TYPES.SET_CONTENT_FILTER_COUNT: {
            return {
                ...state,
                totalContentFilters: action.payload
            }
        }
        case ACTION_TYPES.GET_CONTENT_FILTERS_LOGS: {
            return {
                ...state,
                contentFilterLogs: action.payload?.data
            }
        }
        case ACTION_TYPES.CREATE_CONTENT_FILTER: {
            return {
                ...state,
                createContentFilter: action.payload,
                creatingContentFilter: false
            }
        }
        case ACTION_TYPES.UPDATE_CONTENT_FILTER: {
            return {
                ...state,
                updateCF: action.payload,
                updatingContentFilter: false
            }
        }
        case ACTION_TYPES.DELETE_CONTENT_FILTER: {
            return {
                ...state,
                deleteContentFilter: action.payload,
                deletingContentFilter: false
            }
        }
        default:
            return state
    }
}

export const setLoading = (loading: boolean) => (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: loading })
}

export const setDpIds = (dpIds: string[]) => (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_DP_IDS, payload: dpIds })
}

export interface GetContentFiltersParameters {
    dp_id: string;
    // content_filter_id: string[];
    // name: string[];
    search: string;
    sort_by: string;
    sort_order: string;
    page: number;
    size: number;
}

export const getContentFilters = (parameters: GetContentFiltersParameters) => async (dispatch) => {
    if (_.isEmpty(parameters?.dp_id)) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingContentFilters: true } });
    try {
        let payload = {
            "query": "GET_CF_DASHBOARD",
            "named": true,
            "parameters": {
              "dp_id":parameters.dp_id,
              "sortBy": parameters.sort_by,
              "sortOrder": parameters.sort_order,
              "pageLimit": parameters.size,
              "pageStart": ((parameters.page - 1) * parameters.size),
              "search": parameters.search
            },
            "format": "csv"
        }
        let res = await api.postRequestOut(`/store/pg/query`, payload)
        dispatch({ type: ACTION_TYPES.GET_CONTENT_FILTERS, payload: res});
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingContentFilters: false } });
        return error;
    }
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingContentFilters: false } });
}

export interface CreateContentFilterParameters {
    dp_id: string;
    name: string;
    description: string;
    categories: Category[];
    allowed_domains: Domain[];
    blocked_domains: Domain[];
    enabled:boolean;
}


  const handleCreateCF = (res, dispatch) => {
    if(res.data && res.data.success==false ) {
      toast.error(res.data.errors[0].message, {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
    else if(res && res.success==false ) {
      toast.error(res.errors[0].message, {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
    else{
      toast.success("Content Filter Created Successfully", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
    handleResponseObj(res, dispatch, ACTION_TYPES.CREATE_CONTENT_FILTER)
  }

export const createContentFilter = (parameters: CreateContentFilterParameters, abortSignal: AbortSignal | undefined) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingContentFilter: true } });
    const data = {
        name: parameters.name,
        description: parameters.description,
        categories: parameters.categories,
        allowed_domains: parameters.allowed_domains,
        blocked_domains: parameters.blocked_domains,
        enabled: parameters.enabled,
    }
    
    try {
        let res = await api.siteController.post(`/v1/dps/${parameters.dp_id}/content_filters`, data, {}, abortSignal)
        handleCreateCF(res, dispatch);
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingContentFilter: false } });
        return error;
    }
}

export interface UpdateContentFilterParameters {
    dp_id: string;
    id: string;
    name: string;
    description: string;
    categories: Category[];
    allowed_domains: Domain[];
    blocked_domains: Domain[];
    enabled: boolean;
}

const handleUpdateCF = (res, dispatch) => {
    if(res.data && res.data.success==false ) {
      toast.error(res.data.errors[0].message, {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
    else if(res && res.success==false ) {
      toast.error(res.errors[0].message, {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
    else{
      toast.success("Content Filter Updated Successfully", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
    handleResponseObj(res, dispatch, ACTION_TYPES.UPDATE_CONTENT_FILTER)
}

export const updateContentFilter = (parameters: UpdateContentFilterParameters) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingContentFilter: true } });
    const data = {
        name: parameters.name,
        description: parameters.description,
        categories: parameters.categories,
        allowed_domains: parameters.allowed_domains,
        blocked_domains: parameters.blocked_domains,
        enabled: parameters.enabled,
    }
    
    try {
        let res = await api.siteController.put(`/v1/dps/${parameters.dp_id}/content_filters/${parameters.id}`, data)
        handleUpdateCF(res, dispatch);
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingContentFilter: false } });
        return null;
    }
}

export interface DeleteContentFilterParameters {
    dp_id: string;
    id: string;
}

const handleDeleteCF = (res, dispatch) => {
    if(res.data && res.data.success==false ) {
      toast.error(res.data.errors[0].message, {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
    else if(res && res.success==false ) {
      toast.error(res.errors[0].message, {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
    else{
      toast.success("Content Filter Deleted Successfully", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
    handleResponseObj(res, dispatch, ACTION_TYPES.DELETE_CONTENT_FILTER)
}

export const deleteContentFilter = (parameters: DeleteContentFilterParameters) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { deletingContentFilter: true } });
    try {
        let res = await api.siteController.delete(`/v1/dps/${parameters.dp_id}/content_filters/${parameters.id}`)
        handleDeleteCF(res, dispatch);
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { deletingContentFilter: false } });
        return null;
    }
}

export const clearComponentData = () => (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_DP_IDS, payload: [] })
}

export const getContentFilterLogs = (page, limit, sort, sortOrder, search, dpId) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingContentFilters: true } });
    try {
        let payload = {
            "query": "GET_CF_LOGS",
            "named": true,
            "parameters": {
                "search": search,
                "page_offset": ((page - 1) * limit),
                "page_limit": limit,
                "sort_column": sort,
                "sort_order": sortOrder,
                "dp_id": dpId
            },
            "format": "json"
        }
        let res = await api.postRequestOut(`/store/pg/query`, payload)
        dispatch({ type: ACTION_TYPES.GET_CONTENT_FILTERS_LOGS, payload: res});
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingContentFilters: false } });
        return error;
    }
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingContentFilters: false } });
}

export const applyTrafficPolicy = (dp_id, contentFilterId, payload, abortSignal: AbortSignal | undefined) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { applyingTrafficPolicy: true } });
    try {
        let res = await api.siteController.post(`/v1/dps/${dp_id}/content_filters/${contentFilterId}/applyContentFilter`, payload, {}, abortSignal)
        if(res.hasOwnProperty('success') && res.success) {
            toast.success("Traffic Policy Applied successfully", {
              position: toast.POSITION.BOTTOM_LEFT,
            })
          } else {
            toast.error('Something went wrong, Please try later.', {
              position: toast.POSITION.BOTTOM_LEFT,
            })
          }
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { applyingTrafficPolicy: false } });
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { applyingTrafficPolicy: false } });
        return null;
    }
}